import classNames from "classnames";

import styles from "./Divider.module.scss";

export const DIVIDER_SIZES = ["small"] as const;
export const DIVIDER_ORIENTATIONS = ["horizontal", "vertical"] as const;

export type DiverSizeType = (typeof DIVIDER_SIZES)[number];
export type DividerOrientationType = (typeof DIVIDER_ORIENTATIONS)[number];

interface DividerProps {
  className?: string;
  color?: "nav" | "subMenu";
  size?: DiverSizeType;
  orientation?: DividerOrientationType;
}

// This component renders a horizontal divider with customizable styles.
// It currently has a default color and has the option to change the color based on props.
// You can change the color by passing in a pulse class name but if you are using the component in a specific context,
//   it is better to create a new color variant, right now our design system doesn't have specific color variants so use context based names for these variants.
export const Divider = ({className, color, size, orientation = "horizontal"}: DividerProps) => {
  if (orientation === "vertical") {
    return <div className={classNames(styles.dividerVertical, styles[color || ""], styles[size || ""], className)} />;
  }
  return <hr className={classNames(styles.divider, styles[color || ""], styles[size || ""], className)} />;
};
